// Format token : `wgt_<base64url(meta)>.<base64url(secret)>`.
// `meta` est public (display-only). Le backend reste source de vérité.

const PREFIX = 'wgt_'

export type WidgetMode = 'b2c' | 'agent'

export interface WidgetTokenMetadata {
  orgId: string
  version: number
  mode: WidgetMode | null
  raw: Record<string, unknown>
}

export function parseWidgetToken(value: string | null | undefined): WidgetTokenMetadata | null {
  if (typeof value !== 'string' || !value.startsWith(PREFIX)) return null

  const body = value.slice(PREFIX.length)
  const dot = body.indexOf('.')
  if (dot <= 0) return null

  let decoded: string
  try {
    decoded = base64UrlDecode(body.slice(0, dot))
  } catch {
    // `atob` lève sur un caractère hors alphabet base64 : jeton mal formé, pas une panne.
    return null
  }

  const payload = tryParseJson(decoded)
  if (!payload || typeof payload !== 'object') return null

  const rec = payload as Record<string, unknown>
  if (typeof rec.o !== 'string' || rec.o === '' || typeof rec.v !== 'number') return null

  // `m` (mode) ajouté en 2026-05-19 — backend embed b2c|agent dans la
  // metadata pour bootstrap front sans round-trip HTTP. Token legacy
  // sans `m` → on retombe sur `agent` (comportement historique).
  const rawMode = typeof rec.m === 'string' ? rec.m.toLowerCase() : null
  const mode: WidgetMode | null = rawMode === 'b2c' || rawMode === 'agent' ? rawMode : null

  return { orgId: rec.o, version: rec.v, mode, raw: rec }
}

function base64UrlDecode(input: string): string {
  const padded = input + '='.repeat((4 - (input.length % 4)) % 4)
  return atob(padded.replace(/-/g, '+').replace(/_/g, '/'))
}

function tryParseJson(text: string): unknown {
  try {
    return JSON.parse(text)
  } catch {
    return null
  }
}
